import { create as ipfsHttpClient } from "ipfs-http-client";

const auth =
  "Basic " +
  Buffer.from(
    "2DjNZvYrjruZaOds3iIWXgQzWvS" + ":" + "0ab53090ad04379571a68d615e01ab5d"
  ).toString("base64");

  const client = ipfsHttpClient({
    host: "ipfs.infura.io",
    port: 5001,
    protocol: "https",
    apiPath: '/api/v0',
    headers: {
      Authorization: auth
    }
    });

    export { client };